/** Minimum gap between profile refetches when the app returns to foreground. */
export const FOREGROUND_PROFILE_REFETCH_THROTTLE_MS = 5_000;

/**
 * After this long in background, force-refetch all active React Query caches.
 * Catches hooks with refetchOnWindowFocus: false (e.g. World Cup) and staleTime gaps on web.
 */
export const APP_IDLE_FORCE_REFRESH_MS = 60_000;
